import CustomFormatNumber from "components/CustomFormatNumber";
import ProfitValueCom from "./ProfitValueCom";

const SharesSection = ({
    formatMessage,
    messages,
    totalTokenRemaining,
    investmentAmount,
    sharesIndicativeWealth,
    amountDifference,
    containerClassName = "",
}) => {
    return (
        <div className={`digital-shares mt-15 ${containerClassName}`}>
            <h3 className="mb-8">{formatMessage(messages.yourDigitalShares)}</h3>
            <div className="digital-shares-inner flex justify-between flex-wrap">
                <div>
                    <p className="text-14 another-grey-color mb-1">{formatMessage(messages.amount)}</p>
                    <CustomFormatNumber
                        className="text-16"
                        value={totalTokenRemaining}
                        fixed="0"
                        symbol={formatMessage(messages.shareShortText)}
                    />
                </div>
                <div>
                    <p className="text-14 another-grey-color mb-1">{formatMessage(messages.investmentAmount)}</p>
                    <CustomFormatNumber className="text-16" value={investmentAmount} symbol="€" />
                </div>
                <div>
                    <p className="text-14 another-grey-color mb-1">{formatMessage(messages.indicativeWealthText)}</p>
                    <CustomFormatNumber className="text-16" value={sharesIndicativeWealth} symbol="€" />
                </div>
                <div>
                    <p className="text-14 another-grey-color mb-1">{formatMessage(messages.indicativePerformanceText)}</p>
                    <ProfitValueCom profitData={amountDifference} />
                </div>
            </div>
        </div>
    );
};

export default SharesSection;
